import { isComponent, isElement, isNativeNode, isTextNode, isVirtualNode } from './type_symbol';
const dumpAttributesToString = (elem) => {
    let ret = '';
    if (isElement(elem)) {
        if (elem._$slotName !== null)
            ret += ` (slot) name="${elem._$slotName}"`;
        if (elem.id)
            ret += ` id="${elem.id}"`;
        if (elem.slot)
            ret += ` slot="${elem.slot}"`;
        const nodeClass = elem.class;
        if (nodeClass)
            ret += ` class="${nodeClass}"`;
        const style = elem.style;
        if (style)
            ret += ` style="${elem.style}"`;
    }
    if (isVirtualNode(elem)) {
        // empty
    }
    else if (isComponent(elem)) {
        Object.keys(elem._$behavior._$propertyMap).forEach((propName) => {
            ret += ` ${propName}="${String(elem.data[propName])}"`;
        });
    }
    else {
        elem.attributes.forEach((attr) => {
            ret += ` ${attr.name}="${String(attr.value)}"`;
        });
    }
    return ret;
};
export const dumpSingleElementToString = (elem) => {
    if (isElement(elem)) {
        let tagName;
        if (isVirtualNode(elem)) {
            tagName = `(virtual):${elem.is}`;
        }
        else if (isComponent(elem)) {
            tagName = `${elem.tagName}:${elem.is}`;
        }
        else if (isNativeNode(elem)) {
            tagName = elem.is;
        }
        else {
            tagName = '(unknown)';
        }
        return `<${tagName}${dumpAttributesToString(elem)}>`;
    }
    if (isTextNode(elem)) {
        return elem.textContent.trim();
    }
    if (elem === null) {
        return '<(null)>';
    }
    if (elem === undefined) {
        return '<(undefined)>';
    }
    return '<(unknown)>';
};
export const dumpElementToString = (elem, composed, tabDepth = 0) => {
    let linePrefix = '';
    for (let i = tabDepth; i; i -= 1) {
        linePrefix += '  ';
    }
    let ret = linePrefix + dumpSingleElementToString(elem);
    let isExternal = false;
    if (isElement(elem)) {
        if (isComponent(elem)) {
            isExternal = elem._$external;
        }
        if (composed) {
            if (isExternal) {
                ret += `\n${linePrefix}  <(external)>`;
                elem.forEachComposedChild((node) => {
                    ret += `\n${dumpElementToString(node, composed, tabDepth + 2)}`;
                });
            }
            else {
                elem.forEachComposedChild((node) => {
                    ret += `\n${dumpElementToString(node, composed, tabDepth + 1)}`;
                });
            }
        }
        else {
            elem.childNodes.forEach((node) => {
                ret += `\n${dumpElementToString(node, composed, tabDepth + 1)}`;
            });
        }
    }
    return ret;
};
export const dumpElement = (elem, composed) => {
    // eslint-disable-next-line no-console
    console.log(dumpElementToString(elem, composed));
};
//# sourceMappingURL=node.js.map